export default {
  // 搜索区
  batchSn: 'バッチ番号',
  batchSnPlaceholder: 'バッチ番号を入力',
  codeSn: 'シリアル番号',
  codeSnPlaceholder: 'シリアル番号を入力',
  productName: '製品名',
  productNamePlaceholder: '製品名を入力',
  memberId: 'ユーザーID',
  memberIdPlaceholder: 'ユーザーIDを入力',
  memberName: 'ユーザーニックネーム',
  memberNamePlaceholder: 'ニックネームを入力',
  region: 'スキャン国/地域',
  regionPlaceholder: '選択してください',
  isRepetition: 'スキャン回数',
  isRepetitionPlaceholder: '選択してください',
  firstScan: '初回',
  repeatedScan: '重複スキャン',
  qrcodeType: 'QRコードタイプ',
  qrcodeTypePlaceholder: '選択してください',
  qrcodeTypeBig: '大ラベル',
  qrcodeTypeMid: '中ラベル',
  qrcodeTypeSmall: '小ラベル',
  qrcodeTypeAntiFake: '偽造防止',
  scanTime: 'スキャン時間',
  startTime: '開始時間',
  endTime: '終了時間',
  colBatchNo: 'QRコード バッチ',
  // 操作ボタン
  export: 'エクスポート',
  // テーブル列
  colQrcode: 'QRコード',
  colScanCount: 'スキャン回数',
  colUserInfo: 'ユーザー情報',
  colProductInfo: '製品情報',
  colScanTime: 'スキャン時間',
  colScanRegion: 'スキャン地域',
  colScanIp: 'スキャンIP',
  // スキャン回数
  nthScan: '{count}回目',
  // 空状態
  emptyText: 'スキャン記録なし',
  maxDateRange: '日付範囲は6ヶ月を超えることはできません',
};
